module.exports = __webpack_public_path__ + "img/Numberofassociations.1d121f17.png";